import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, Tooltip } from "@mui/material";
import AttachmentItem from "components/Attachments/AttachmentItem";
import CopyAttachmentButton from "components/Attachments/CopyAttachmentButton";
import { getFileIcon, getOriginalFileName } from "utils/utils";

const FileAttachment = ({ url, onRemove }) => (
  <div className="flex max-w-full items-center gap-1.5 rounded-md border border-app-border bg-app-surface px-2 py-1">
    <span className="flex h-4 w-4 flex-shrink-0 items-center justify-center text-xs">
      {getFileIcon(url)}
    </span>
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title={getOriginalFileName(url) || "File"}
      className="max-w-[180px] truncate text-xs text-primary hover:underline"
    >
      {getOriginalFileName(url) || "File"}
    </a>
    <CopyAttachmentButton url={url} />
    {onRemove && (
      <Tooltip title="Remove attachment">
        <IconButton size="small" onClick={onRemove} aria-label="Remove attachment">
          <ClearIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    )}
  </div>
);

const CommentAttachments = ({ attachments = [], onRemove }) => {
  if (!attachments.length) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {attachments.map((url, index) => {
        const remove = onRemove ? () => onRemove(index) : undefined;
        return (
          <AttachmentItem
            key={`${url}-${index}`}
            url={url}
            onRemove={remove}
            renderFile={(fileUrl) => <FileAttachment url={fileUrl} onRemove={remove} />}
          />
        );
      })}
    </div>
  );
};

export default CommentAttachments;
